import { ResponsiveStyleValue } from '@mui/system';
import { ReactNode, RefCallback, RefObject, type JSX } from 'react';

export type MicroPortalDrawerType = 'drawer-right' | 'drawer-left' | 'drawer-bottom'

export type MicroPortalType = 'href' | 'custom-element' | 'dialog' | MicroPortalDrawerType;

interface MicroPortalCommonProps {
  app: string;
  data?: Record<string, string>;
  devHost?: string;
  onError?: (error: Error) => void;
  scrolling?: string;
  errorFallback?: (error: string) => ReactNode;
  iframeRef?: RefCallback<HTMLIFrameElement> | RefObject<HTMLIFrameElement | undefined>;
}

export interface MicroPortalProps extends MicroPortalCommonProps {
  title?: string;
  onSuccess?: () => void;
  loadingFallback?: ReactNode;
  testId?: string;
  token?: string;
  height?: number;
  autoResize?: boolean;
}

export interface MicroPortalLauncherProps extends MicroPortalCommonProps {
  app: string;
  type?: MicroPortalType;
  width?: string | ResponsiveStyleValue<string>;
  height?: string | ResponsiveStyleValue<string>;
  element?: ReactNode;
  loadingElement?: ReactNode;
  isPersistent?: boolean;
  isDismissible?: boolean;
  onSuccess?: () => void;
}

export interface MicroPortalDrawerProps {
  children: ReactNode;
  closeType: 'close-button' | 'outside-click';
  isOpen: boolean;
  keepMounted?: boolean;
  height?: ResponsiveStyleValue<string>;
  onClose: VoidFunction;
  type: MicroPortalDrawerType;
  width?: ResponsiveStyleValue<string>;
}

export interface MicroPortalDialogProps {
  children: ReactNode;
  isOpen: boolean;
  isDismissible?: boolean;
  keepMounted?: boolean;
  height?: ResponsiveStyleValue<string>;
  onClose: VoidFunction;
  width?: ResponsiveStyleValue<string>;
}

export interface MicroPortalLauncherPageActionProps {
  icon?: JSX.Element;
  label: ReactNode;
  testId?: string;
  launcherProps: Omit<MicroPortalLauncherProps, 'element'>;
}

export interface MicroPortalConfig {
  app: string;
  type: 'dialog';
  action: {
    icon?: string;
    tooltip?: string;
  };
  data: {
    feature: string;
    name: string;
  };
  element: ReactNode;
  isDismissible?: boolean;
}

export enum MicroPortalMessageType {
  REFRESH = 'REFRESH',
  CLOSE = 'CLOSE',
  RESIZE = 'RESIZE'
}
